import { baseApi } from './axios';

export const startAssessment = async ({ forPractice, publishedItemId }: { forPractice?: boolean; publishedItemId: string }) => {
	const response = await baseApi.get(`/assessment/${publishedItemId}/enrol?forPractice=${forPractice}`);
	return response;
};

export const getUserAssessmentSubmission = async ({ publishedItemId }: { publishedItemId?: string }) => {
	const response = await baseApi.get(`/user-assessment/${publishedItemId}`);
	return response;
};

export const joinEliteProgram = async ({ publishedItemId }: { publishedItemId?: string }) => {
	const response = await baseApi.patch(`/user-assessment/${publishedItemId}`);
	return response;
};

export const getAllUsersAssessmentSubmissions = async ({ publishedItemId }: { publishedItemId?: string }) => {
	const response = await baseApi.get(`/user-assessment/${publishedItemId}/all`);
	return response;
};
